import { render, staticRenderFns } from "./ApeDrawer.vue?vue&type=template&id=4f87f55e&scoped=true"
import script from "./ApeDrawer.vue?vue&type=script&scoped=true&lang=js"
export * from "./ApeDrawer.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./ApeDrawer.vue?vue&type=style&index=0&id=4f87f55e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f87f55e",
  null
  
)

export default component.exports